import { AnchorButton as BlueprintAnchorButton } from '@blueprintjs/core';
import { ChevronDown } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';

import { useNavbarSchema } from 'bones/components/molecules/Navbar/context/NavbarSchema';
import { Icon } from 'bones/design-system/components/icons/Icon';

export interface NavbarDropdownProps {
  isDropdownOpen: boolean;
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavbarDropdown: React.VFC<NavbarDropdownProps> = ({
  isDropdownOpen,
  setIsDropdownOpen,
}) => {
  const { expand, dropdown } = useNavbarSchema();

  return (
    <div
      className={classNames('vb-navbar-dropdown', {
        'vb-navbar-dropdown--closed': !isDropdownOpen,
        'vb-navbar-dropdown--open': isDropdownOpen,
      })}
      onMouseEnter={() => {
        setIsDropdownOpen(true);
      }}
    >
      <div className="vb-navbar-dropdown-selected">
        <BlueprintAnchorButton
          active={isDropdownOpen}
          className="vb-navbar-dropdown-button"
          data-testid={dropdown.selectedItem.testId}
          onClick={() => {
            setIsDropdownOpen(false);
            dropdown.selectedItem.onClick();
          }}
        >
          {expand.isExpanded ? (
            <>
              {dropdown.selectedItem.expanded}
              {dropdown.items?.length ? (
                <Icon IconComponent={ChevronDown} size="sm" />
              ) : null}
            </>
          ) : (
            dropdown.selectedItem.collapsed
          )}
        </BlueprintAnchorButton>
      </div>
      {dropdown.items?.length ? (
        <div className="vb-navbar-dropdown-buttons">
          {dropdown.items.map((item) => (
            <BlueprintAnchorButton
              key={item.key || item.testId}
              active
              className="vb-navbar-dropdown-button"
              data-testid={item.testId}
              onClick={() => {
                setIsDropdownOpen(false);
                item.onClick();
              }}
            >
              {expand.isExpanded ? item.expanded : item.collapsed}
            </BlueprintAnchorButton>
          ))}
        </div>
      ) : null}
    </div>
  );
};
